
/**
 * @export
 * @enum {string}
 */
export enum DraftSortField {
    CREATED_AT = 'CREATED_AT',
    FINISHED_AT = 'FINISHED_AT',
    UPDATED_AT = 'UPDATED_AT',
    SSO_ENABLED = 'SSO_ENABLED',
    SSO_MANDATORY = 'SSO_MANDATORY',
    CURRENT_STEP = 'CURRENT_STEP',
    STATUS = 'STATUS',
    ERRORS = 'ERRORS'
}